import { useEffect, useState } from 'react';
import { GridRowsProp, GridColDef } from '@mui/x-data-grid';
import DataTable from '../../components/DataTable';
import { Box, Button, Grid, Pagination } from '@mui/material';
import { GLOBAL_CONSTANTS, ROUTES, TOASTER_CONFIGS } from '../../constants';
import { useNavigate } from 'react-router-dom';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import HttpsIcon from "@mui/icons-material/Https";
import LockOpenTwoToneIcon from "@mui/icons-material/LockOpenTwoTone";
import { useAdminListMutation, useEmployeeDeleteMutation, useEmployeeListMutation, useGuestEmployeeListMutation } from '../../service/apiSlices/accessApiService';
import { toast } from 'react-toastify';
import moment from 'moment';
import { checkEmpty } from '../../utils/helper';
import './ManageAdminComponent.scss';

const ManageAdminComponent = () => {
    const navigate = useNavigate();
    const [employeeListApiCall] = useEmployeeListMutation();
    //
    const [adminListApiCall] = useAdminListMutation();


    const [guestListApiCall] = useGuestEmployeeListMutation();
    const [deleteApiCall] = useEmployeeDeleteMutation();
    const [GuestEmployeeActive, setGuestEmployeeActive] = useState(false)
    const [page, setPage] = useState(1);
    const [totalPage, setTotalCount] = useState(0);
    const [rowPerPage, setRowPerPage] = useState(10);
    const [hasProducts, setHasProducts] = useState(false);
    const [EmployeeList, setEmployeeList] = useState([]);
    const [GuestList, setGuestList] = useState([]);

    const rows: GridRowsProp = EmployeeList ?? [];
    const rowsGuest: GridRowsProp = GuestList ?? [];

    const navigateEditValue = (id: any) => {
        navigate(ROUTES.MANAGEEMPLOYEE_add + `/${id}`)
    }

    useEffect(() => {
        if (GuestEmployeeActive) {
        } else {
            // GetEmployeeListApiCall();
            GetAdminListApiCall();
        }
    }, [page, rowPerPage, GuestEmployeeActive])

    // const GetEmployeeListApiCall = async () => {
    //     var payload = { page: page, limit: rowPerPage }
    //     await employeeListApiCall(payload)
    //         .unwrap()
    //         .then((response) => {
    //             setEmployeeList(response?.result?.data);
    //             setTotalCount(response.result.total_page);
    //             console.log(response.result.total_page,"count 11111");

    //             setHasProducts(checkEmpty(response?.result?.data));
    //         })
    //         .catch(() => { })
    // }

    const GetAdminListApiCall = async () => {
        var payload = { page: page, limit: rowPerPage }
        await adminListApiCall(payload)
            .unwrap()
            .then((response) => {
                setEmployeeList(response?.result?.data);
                setTotalCount(response.result.total_page);
                setHasProducts(checkEmpty(response?.result?.data));
            })
            .catch(() => { })
    }


    const columns: GridColDef[] = [
        { field: 'fullname', headerName: 'Full Name', width: 200 },
        { field: 'department_name', headerName: 'Category Name', width: 250 },
        { field: 'email', headerName: 'Email', width: 250 },
    ];

    const columnsGuest: GridColDef[] = [
        { field: 'fullname', headerName: 'Name', width: 200 },
        { field: 'email', headerName: 'Email', width: 250 },
        { field: 'phone_number', headerName: 'Phone number', width: 200 },
        {
            field: 'created_on', headerName: 'Created Date', width: 150,
            renderCell: (params) => (
                <>
                    {moment(params.row.created_on).format('DD/MM/YYYY')}
                </>
            ),
        },
    ];


    const blockUnblockDeparment = (id: any) => {
        deleteApiCall(id)
            .unwrap()
            .then((response) => {
                // GetEmployeeListApiCall();
                toast.success(response?.message, TOASTER_CONFIGS);
            })
            .catch((error) => {
                toast.error(error?.data?.message, TOASTER_CONFIGS);
            })

    }

    /**Handle row per page change */
    const onRowChange = (event: any) => {
        setPage(1);
        setRowPerPage(parseInt(event.target.value));
    };

    /* Handle page change */
    const handleChangePage = (event: React.ChangeEvent<any>, newPage: number) => {
        setPage(newPage);
    };

    return (
        <div>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    justifyContent: 'space-between'
                }}
            >

                {!GuestEmployeeActive && (
                    <Button type="button" variant="contained" onClick={() => navigate(ROUTES.CREATE_ADMIN)}
                        sx={{ mb: 2, background: `${GLOBAL_CONSTANTS.COLOR_CODE.GRADIENT}` }}>
                        Add Admin
                    </Button>
                )}

            </Box>
            {GuestEmployeeActive ? (
                <DataTable rows={rowsGuest} columns={columnsGuest} />
            ) : (
                <DataTable rows={rows} columns={columns} />
            )}

            {hasProducts && (
                <div className="tablePagination">
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={7}>
                            <div className="pagination-wrap">
                                <Pagination
                                    count={totalPage}
                                    page={page}
                                    onChange={handleChangePage}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                            <div className="rows-per-page">
                                <p>Rows per page</p>
                                <select
                                    className="rows-select"
                                    value={rowPerPage}
                                    onChange={onRowChange}
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                </select>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            )}
        </div>
    )
}

export default ManageAdminComponent;